import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const Image = ({
  src,
  src2x,
  useWebp = false,
  className,
  lazy = false,
  srcWebp,
  src2xWebp,
  ...props
}) => {
  const [isLazy, setIsLazy] = useState(props.fetchPriority ? lazy : true);
  const srcSet = useMemo(() => (src2x ? `${src} 1x, ${src2x} 2x` : undefined), [src2x, src]);
  const srcSetWebp = useMemo(() => {
    const srcSource = srcWebp || `${src}.webp`;
    const src2xSource = src2xWebp || (src2x ? `${src2x}.webp` : `${src}.webp`);
    return src2xWebp || src2x ? `${srcSource} 1x, ${src2xSource} 2x` : srcSource;
  }, [src2x, src, srcWebp, src2xWebp]);

  useEffect(() => {
    if (lazy) return;
    setIsLazy(false);
  }, [lazy]);

  if (useWebp) {
    return (
      <picture className={className} {...props}>
        <source srcSet={srcSetWebp} type="image/webp" />
        <img
          alt={props.alt}
          src={src}
          srcSet={srcSet}
          loading={isLazy ? 'lazy' : 'eager'}
          data-src={src}
          data-srcset={srcSet}
          fetch-priority={props.fetchPriority}
        />
      </picture>
    );
  }

  return (
    <img
      className={className}
      src={src}
      srcSet={srcSet}
      data-src={src}
      data-srcset={srcSet}
      loading={isLazy ? 'lazy' : 'eager'}
      alt={props.alt}
      {...props}
    />
  );
};

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
  useWebp: PropTypes.bool,
  src2x: PropTypes.string,
  lazy: PropTypes.bool,
  srcWebp: PropTypes.string,
  src2xWebp: PropTypes.string,
  fetchPriority: PropTypes.bool,
};

export default Image;
